import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagVU = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M50 25a25.24 25.24 0 0 0-.21-3.26H21.74L7.323 7.321c-9.763 9.763-9.763 25.592 0 35.356L21.74 28.26h28.05A25.26 25.26 0 0 0 50 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m49.991 25.568-.004.145.004-.145ZM49.967 26.251l-.008.143.008-.143ZM49.933 26.796l-.016.21.016-.21ZM49.85 22.275c.01.083.018.167.027.25l-.027-.25ZM49.959 23.605l.008.143-.008-.143ZM49.987 24.286l.004.145a34.606 34.606 0 0 0-.004-.145ZM49.917 22.993l.016.21-.016-.21Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m49.79 21.74.03.257C48.338 9.606 37.791 0 25 0A24.921 24.921 0 0 0 7.324 7.323L21.74 21.739h28.05Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M49.79 28.26H21.74L7.322 42.678A24.922 24.922 0 0 0 25.001 50c12.79 0 23.336-9.606 24.82-21.997-.01.086-.02.172-.032.258Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m49.877 27.474-.027.25c.01-.083.019-.166.027-.25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M49.935 23.203ZM49.819 21.996ZM49.878 22.526ZM50 25ZM49.96 26.395ZM49.92 27.007ZM49.85 27.724ZM49.993 24.431ZM49.97 23.748ZM49.99 25.713Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M49.977 23.904H20.822L5.846 8.93a12.767 12.767 0 0 0-1.334 1.731l14.322 14.33L4.5 39.325c.284.505.902 1.252 1.336 1.738l14.986-14.985h29.159a25.305 25.305 0 0 0-.004-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M6.074 30.329v-2.094c2.09 0 3.79-1.7 3.79-3.79a2.684 2.684 0 0 0-2.682-2.68c-1.007 0-1.826.819-1.826 1.826a1.17 1.17 0 0 0 1.168 1.168c.364 0 .66-.297.66-.66h2.094a2.757 2.757 0 0 1-2.754 2.754 3.266 3.266 0 0 1-3.262-3.262 3.925 3.925 0 0 1 3.92-3.92 4.78 4.78 0 0 1 4.776 4.774 5.89 5.89 0 0 1-5.884 5.884Z"
}));
FlagVU.displayName = 'FlagVU';
export default withFlagWrapper(FlagVU);
//# sourceMappingURL=index.js.map